<template>
  <section lazy-animation="slide-left" class="fixed left-5 bottom-5 w-60 z-50">
    <div
      v-if="show"
      class="rounded-full w-full h-11 flex border border-black dark:border-white dark:bg-dark-mode bg-white dark:text-white text-black"
    >
      <a
        target="_blank"
        rel="noopener noreferrer"
        class="flex flex-1 items-center px-5 gap-2"
        href="https://docs.google.com/forms/d/e/1FAIpQLScPerKg-freDOobJbRt_X1XUnG5Y6Y3HC2YwQwhiwOLrvpiCA/viewform?usp=dialog"
      >
        <i class="fa-solid fa-link text-xs"></i>
        <p>{{ $t("message.notifications.join") }}</p>
      </a>
      <div class="flex items-center justify-center px-4">
        <i class="fa-solid fa-xmark cursor-pointer" @click="show = false"></i>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Notifications",
  data() {
    return {
      show: true,
    };
  },
};
</script>
